import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, Flex, Typography } from 'antd';

import AiIcon from '../../../../../components/AiIcon';

import { useHomeMessageId } from '../../../hooks/useHomeMessageId';
import { useHomeAuthModal } from '../HomeAuthModalContext';

const { Title } = Typography;
const finalPng = '/home/assets/final.png';

const FinalCta = () => {
  const { openRegister } = useHomeAuthModal();
  const homeMessageId = useHomeMessageId();

  return (
    <section className="home-page__final-cta">
      <div
        className="home-page__final-visual"
        aria-hidden
        style={{
          backgroundImage: `url(${finalPng})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
        }}
      />
      <Title level={2}>
        <FormattedMessage id={homeMessageId('finalCta.title')} />
      </Title>
      <Flex justify="center">
        <Button className="btn-gradient btn-xl" onClick={openRegister}>
          <FormattedMessage id={homeMessageId('button.createAccount')} />
          <AiIcon name="btn-primary-circle-arrow-lg" />
        </Button>
      </Flex>
    </section>
  );
};

export default FinalCta;
